// MARK:- Click-to-load YouTube facade
// Renders nothing itself. The markup is a local CSS poster wrapped around a real
// link to the video on youtube.com, emitted either by
// snippets/custom-youtube-facade.liquid or authored by hand in Shopify admin
// (collection descriptions, pages, articles). Nothing is requested from a Google
// or YouTube host until someone clicks; the click is intercepted here and the
// privacy-enhanced embed is created in place. With this script absent or blocked,
// the link still works and takes the shopper to the video.
(() => {
  const FACADE_SELECTOR = '.custom-yt-facade';
  const TRIGGER_SELECTOR = '.custom-yt-facade__button';
  const LOADED_CLASS = 'custom-yt-facade--loaded';

  // MARK:- Swap the poster for the privacy-enhanced embed
  const loadVideo = (facade) => {
    const videoId = facade.dataset.videoId;
    if (!videoId) return false;

    const params = new URLSearchParams({ autoplay: '1', rel: '0', playsinline: '1' });
    const iframe = document.createElement('iframe');

    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${params}`;
    iframe.title = facade.dataset.videoTitle || '';
    iframe.className = 'custom-yt-facade__iframe';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('frameborder', '0');

    facade.replaceChildren(iframe);
    facade.classList.add(LOADED_CLASS);
    iframe.focus();
    return true;
  };

  // MARK:- One delegated listener covers the snippet, admin-authored markup, and anything rendered later
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    const facade = trigger.closest(FACADE_SELECTOR);
    if (!facade || facade.classList.contains(LOADED_CLASS)) return;

    if (loadVideo(facade)) event.preventDefault();
  });

  // MARK:- Keep the element name registered so existing snippet markup behaves as before
  if (!customElements.get('custom-youtube-facade')) {
    customElements.define('custom-youtube-facade', class extends HTMLElement {});
  }
})();
